
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 5l1.273 3.227L15 9.5l-3.227 1.273L10.5 14l-1.273-3.227L6 9.5l3.227-1.273L10.5 5zM16.566 11.5L16 10.066l-.566 1.434-1.434.566 1.434.565.566 1.435.566-1.435L18 12.066l-1.434-.566zM6 15h8v2H6v-2zM18 15h-2v2h2v-2z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 2v20h20V2H2zm18 2H4v16h16V4z"}})])
          )
        }
      }
    